export const REGIONS = {
  IN: "in",
  ROW: "row",
};

export const REGION_STORAGE_KEY = "praesidio-region";
export const REGION_CHANGE_EVENT = "praesidio-region-change";

export function getRegion() {
  try {
    const value = window.localStorage.getItem(REGION_STORAGE_KEY);
    if (value === REGIONS.IN || value === REGIONS.ROW) return value;
  } catch {
    /* private mode */
  }
  return null;
}

export function setRegion(region) {
  if (region !== REGIONS.IN && region !== REGIONS.ROW) return;
  try {
    window.localStorage.setItem(REGION_STORAGE_KEY, region);
  } catch {
    /* private mode */
  }
  window.dispatchEvent(new CustomEvent(REGION_CHANGE_EVENT, { detail: region }));
}

export function isIndiaPath(pathname = "") {
  return (
    pathname === "/in" ||
    pathname === "/india" ||
    pathname === "/entering-in" ||
    pathname.startsWith("/in/")
  );
}
